<template>
    <div id="RuleDescription" class="wrap">
        <van-nav-bar
        :fixed="true"
        placeholder
        :title="$t('My.RuleDescription.RuleDescription')"
        left-arrow
        @click-left="onClickLeft"
        />
        <div class="content">
            <div class="Text">
                <p>{{$t('My.RuleDescription.One')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Two')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Three')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Four')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Five')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Six')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Seven')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Eight')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Nine')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Ten')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Eleven')}}</p>
                <br>
                <p class="p-text">{{$t('My.RuleDescription.OneData.One')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.OneData.Two')}}</p>
                <p>{{$t('My.RuleDescription.OneData.Three')}}</p>
                <p>{{$t('My.RuleDescription.OneData.Four')}}</p>
                <p>{{$t('My.RuleDescription.OneData.Five')}}</p>
                <p>{{$t('My.RuleDescription.OneData.Six')}}</p>
                <br>
                <p class="p-text">{{$t('My.RuleDescription.TwoData.One')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.TwoData.Two')}}</p>
                <p>{{$t('My.RuleDescription.TwoData.Three')}}</p>
                <p>{{$t('My.RuleDescription.TwoData.Four')}}</p>
                <p>{{$t('My.RuleDescription.TwoData.Five')}}</p>
                <p>{{$t('My.RuleDescription.TwoData.Six')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.FourData.One')}}</p>
                <p>{{$t('My.RuleDescription.FourData.Two')}}</p>
                <p>{{$t('My.RuleDescription.FourData.Three')}}</p>
                <p>{{$t('My.RuleDescription.FourData.Four')}}</p>
                <p>{{$t('My.RuleDescription.FourData.Five')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.FiveData.One')}}</p>
                <p>{{$t('My.RuleDescription.FiveData.Two')}}</p>
                <p>{{$t('My.RuleDescription.FiveData.Three')}}</p>
                <p>{{$t('My.RuleDescription.FiveData.Four')}}</p>
                <p>{{$t('My.RuleDescription.FiveData.Five')}}</p>
                <br>
                <p>{{$t('My.RuleDescription.Twelve')}}</p>
                <br>
                <van-image  width="100%"  :src="require('@/assets/Img/myImg/Pengaturan.jpg')" />
            </div>
        </div>
    </div>
</template>

<script>
    import {
        Row,
        Col,
        Icon,
        Cell,
        GridItem,
        Grid,
        NavBar,
        ActionSheet,
        Button,
        Image 
    }from "vant";

    export default {
        name:"RuleDescription",
        components: {
            [Row.name]: Row,
            [Col.name]: Col,
            [Icon.name]: Icon,
            [Cell.name]: Cell,
            [GridItem.name]: GridItem,
            [Grid.name]: Grid,
            [NavBar.name]: NavBar,
            [ActionSheet.name]: ActionSheet,
            [Button.name]: Button,
            [Image.name]:Image
        },
        data(){
            return{
                
            }
        },
        methods:{
            // 返回上一个路由
            onClickLeft(){
                this.$router.go(-1);
            },
        
        },
        created() {
            window.scroll(0, 0);
        },
    }
</script>

<style lang="less">
    #RuleDescription{
        width: 100%;
        height: 100%;
        .content{
            width: calc(100% - 1.25rem);
            padding: 0.9375rem 0.625rem;
            background-color: #f2f2f2;
            >.Text{
                width: calc(100% - 1.25rem);
                padding: 1.25rem 0.625rem;
                border-radius: 0.625rem;
                background-color: #fff;
                font-size: 14px;
                color: #333;
                .p-text{
                    font-weight: 800;
                }
            }
        }
    }
</style>